import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import {StoreManager} from 'sagamatic';

import {GameActions} from './redux/actions/game_actions';
import * as GameSagas from './redux/sagas/game_sagas';
import RootReducer from './redux/root-reducer';
import Theme from './theme/theme';

import 'typeface-roboto';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#eeeeee',
    height: '100vh',
  },
}));

const Bow = function() {
  const classes = useStyles();
  const isDev = process.env.NODE_ENV === 'development';

  const storeManager = new StoreManager({devToolsEnabled: isDev});
  storeManager.addSaga(GameActions.ADVANCE_FOR_SURVIVAL, GameSagas.advanceForSurvival);
  storeManager.addSaga(GameActions.CLEAR, GameSagas.clear);
  storeManager.addSaga(GameActions.GO, GameSagas.go);
  storeManager.addSaga(GameActions.TAKE_LETTER, GameSagas.takeLetter);
  storeManager.addSaga(GameActions.TAKE_VOWEL, GameSagas.takeVowel);
  storeManager.addSaga(GameActions.UPDATE_BEST_WORDS, GameSagas.updateBestWords);
  storeManager.addSaga(GameActions.RESTORE, GameSagas.restore);
  storeManager.addSaga(GameActions.VOWEL, GameSagas.vowel);
  const store = storeManager.createStore(RootReducer);

  return (
    <div className={classes.root}>
      <Provider store={store}>
        <Theme />
      </Provider>
    </div>
  );
};

const mount = document.getElementById('app');
ReactDOM.render(<Bow/>, mount);
